import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IState {
    isUpdate?: boolean,
    campaignId: number | null
}

const initialState: IState = {
    isUpdate  : false,
    campaignId: null
};

export const updateCampaignStatus = createSlice({
    initialState,
    name    : 'update-campaign-status',
    reducers: {
        reset: () => initialState,
        set  : (state, action: PayloadAction<Partial<IState>>) => {
            return {
                ...state,
                ...action.payload
            };
        }
    }
});

export default updateCampaignStatus.reducer;
